import { ActionTypes } from "./constants";

const setGraphData = (payload) =>({ type: ActionTypes.SET_GRAPH_DATA, payload: payload });
const setSelectedParams = (payload) =>({ type: ActionTypes.SET_SELECTED_PARAMS, payload: payload });
const setGraphRendering = (payload) =>({ type: ActionTypes.SET_GRAPH_RENDERING, payload: payload });
const addSelectedParams = (payload) =>({ type: ActionTypes.ADD_SELECTED_PARAMS, payload: payload });
const deleteSelectedParams = (payload) =>({ type: ActionTypes.DELETE_SELECTED_PARAMS, payload: payload });
const setListParams = (payload) =>({ type: ActionTypes.SET_LIST_PARAMS, payload: payload });
const setVisible = (payload) =>({ type: ActionTypes.SET_VISIBLE, payload: payload });

const CompareGraphActions = {
    setGraphData,
    setSelectedParams,
    setGraphRendering,
    addSelectedParams,
    deleteSelectedParams,
    setListParams,
    setVisible,
}

export default CompareGraphActions;
